/* eslint-disable max-len */
import React, { useEffect, useContext } from 'react';
import { createPortal } from 'react-dom';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { StickyWithHeaderObserver } from '@thd-olt-component-react/sticky';
import { DraggableDrawer } from './MagicApronAssistant/subcomponents/drawer/DraggableDrawer';
import { getPortalRootNode } from '../utils/assistant-utils';
import './ResponsiveAssistant.scss';

export const ResponsiveAssistant = ({ drawerState, setDrawerState, offsetMargin, children = null }) => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  const portalRootNode = getPortalRootNode();

  useEffect(() => {
    const rootEl = document.getElementById('root');
    if (!isMobile && rootEl) rootEl.classList.add('magic-apron-assistant-root');

    return () => {
      if (!isMobile && rootEl) {
        rootEl.classList.remove('magic-apron-assistant-root');
      }
    };
  }, []);

  return (
    <ErrorBoundary name="magic-apron-assistant-with-portal">
      {isMobile && (
      // StickyWithHeaderObserver has z-index of 899 that we can't override so need to wrap to be on top of header/footer
        // eslint-disable-next-line tailwindcss/no-arbitrary-value
        <div className="sui-z-[998] sui-relative">
          {/* Overlay to darken background when drawer is open */}
          {drawerState === 'OPEN' && <div className="sui-fixed sui-inset-0 sui-bg-inverse/50" />}
          <StickyWithHeaderObserver
            className="sui-w-full sui-left-0"
            position="bottom"
            stickyByDefault
            visibleByDefault
            offsetMargin={offsetMargin}
          >
            <DraggableDrawer
              drawerState={drawerState}
              setDrawerState={setDrawerState}
              onClose={() => { }}
            >
              {children}
            </DraggableDrawer>
          </StickyWithHeaderObserver>
        </div>
      )}
      {!isMobile && (portalRootNode !== null ? createPortal(
        <aside
          id="magic-apron-assistant-drawer"
          // eslint-disable-next-line tailwindcss/no-arbitrary-value
          className="sui-sticky sui-flex sui-flex-col sui-h-[calc(100vh-169px)] sui-top-[169px] sui-ml-3 sui-mr-4 sui-border-solid sui-border-1 sui-border-primary"
        >
          {children}
        </aside>, portalRootNode
      )
        : (
          <aside
            id="magic-apron-assistant-drawer"
            // eslint-disable-next-line tailwindcss/no-arbitrary-value
            className="sui-sticky sui-flex sui-flex-col sui-h-[calc(100vh-169px)] sui-top-[169px] sui-ml-3 sui-mr-4 sui-border-solid sui-border-1 sui-border-primary"
          >
            {children}
          </aside>
        ))}
    </ErrorBoundary>
  );
};